'use client';
import dynamic from "next/dynamic";
import { usePathname } from "next/navigation";
import { use, useEffect, useState } from "react";
const UserFormModal = dynamic(() => import("@/components/UserFormModal"), {
    ssr: false,
});

const DISPLAY_DELAY_MS = 20 * 1000; // 20 seconds after page load
const CACHE_DURATION_MS = 24 * 60 * 60 * 1000; // 24 hours



const FormModalClient = () => {

    const [open, setOpen] = useState(false);
    const pathname = usePathname();
    useEffect(() => {

        if (pathname === "/application") return;

        const lastShown = localStorage.getItem("formLastShown");
        const now = Date.now();

        const hasBeenShownRecently =
            lastShown && now - Number(lastShown) < CACHE_DURATION_MS;

        if (hasBeenShownRecently) return; // Still within 24h, do nothing

        const displayTimer = setTimeout(() => {
            setOpen(true);
            localStorage.setItem("formLastShown", String(Date.now()));
        }, DISPLAY_DELAY_MS);

        return () => clearTimeout(displayTimer);
    }, []);



    const handleClose = () => {
        setOpen(false);
    }
    return (
        <div>
            <UserFormModal isOpen={open} onClose={handleClose} />
        </div>
    );
}
export default FormModalClient;